import jsPDF from 'jspdf';
import dayjs from 'dayjs';
import laiSenBale from "../../../../assets/images/license/oneBell.png";
import arabicToThai from '../../../../hook/arabicToThai';

export async function ReprintDemandGuaranter(dataReprintDemandGuaranter, type) {

    const [convertToThaiNumerals, toThaiWord, numberToThaiText] = arabicToThai();


    if (dataReprintDemandGuaranter[0].ContractSchema === 'rpsl') {
        const doc = new jsPDF('p', 'mm', 'a4');

        dataReprintDemandGuaranter.forEach((item, index) => {

            if (index > 0) doc.addPage();

            let y = 20; // ตำแหน่ง Y เริ่มต้น
            const lineHeight = 8; // ระยะห่างบรรทัด (สำคัญเพื่อให้ดูเหมือนเอกสารจริง)

            doc.setFont('THSarabunNew', 'normal');
            doc.setFontSize(14);

            // --- ส่วนหัว (ชื่อบริษัทและที่อยู่) ---
            doc.setFont('THSarabunNew', 'normal');


            const address = `
                    ชื่อลูกค้า:     ${item.SNAM + item.NAME1 + ' ' + item.NAME2} (คนค้ำ ${item?.GARNO}) (${item?.CONTNO})
                    ที่อยู่:          ${item?.ADDR1} 
                                    ต.${item?.TUMB} อ.${item?.AUMPDES} จ.${item?.PROVDES} ${item?.ZIP}
                    เบอร์โทร:    ${item?.TELP}
                                    (${dayjs(item.RoundDate).format('DD/MM/YYYY')})
        `;
            doc.text(address, 5, y);
            y += 67;

            // --- วันที่ ---
            const dataNow = dayjs(item.RoundDate).format('DD/MM/YYYY'); // เปลี่ยนเป็นวันที่ยึด

            doc.text(`วันที่ ${dataNow}`, 160, y, { align: 'right' });
            y += 10;


            const s1 = `
        เรื่อง แจ้งให้ชำระค่าเช่าซื้อที่ค้างชำระ สัญญาเช่าซื้อเลขที่ (${item?.CONTNO})
        `;
            doc.text(s1, 5, y);
            y += 7;

            const s2 = `
        เรียน ${item.SNAM + item.NAME1 + ' ' + item.NAME2} 
        `;
            doc.text(s2, 5, y);
            y += 22;

            // --- เนื้อหา Paragraph 1 ---
            doc.setFont('THSarabunNew', 'normal');

            doc.text(`ตามที่ท่านผู้กู้ได้ตกลงทำสัญญากู้ยืมเงินจำนวน`, 25, y);
            doc.setFont("THSarabunNew", "bold");

            const tcarcst = Number(item?.TCARCST ?? 0).toLocaleString('th-TH', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            // const amount = Number(item.EXP_AMT) || 0;
            const tcarcstThaiText = numberToThaiText(tcarcst);

            doc.text(`${tcarcst} บาท (${tcarcstThaiText})`, 90, y);
            doc.setFont('THSarabunNew', 'normal');
            doc.text('ไปจากบริษัท', 165, y);

            y += lineHeight;

            // doc.setFont('THSarabunNew', 'normal');
            doc.text('วัน มันนี่ จำกัด (สำนักงานใหญ่) ตามสัญญากู้ยืมเงิน ลงวันที่', 15, y);
            doc.setFont("THSarabunNew", "bold");
            doc.text(`${dayjs(item.SDATE).format('DD/MM/YYYY')}`, 95, y);
            doc.setFont('THSarabunNew', 'normal');
            doc.text('โดยผู้กู้ได้รับเงินไปครบถ้วนแล้วและได้สมุคคู่มือ', 120, y);

            y += lineHeight;

            doc.text(`จดทะเบียนรถยนต์ ยี่ห้อ `, 15, y);
            doc.setFont("THSarabunNew", "bold");
            doc.text(`${item.TYPE}`, 50, y);
            doc.setFont('THSarabunNew', 'normal');
            doc.text(`เลขตัวถัง`, 75, y);
            doc.setFont("THSarabunNew", "bold");
            doc.text(`${item.STRNO}`, 90, y);
            doc.setFont('THSarabunNew', 'normal');
            doc.text(`เลขเครื่อง `, 135, y);
            doc.setFont("THSarabunNew", "bold");
            doc.text(`${item.ENGNO}`, 155, y);

            y += lineHeight;

            doc.setFont('THSarabunNew', 'normal');
            doc.text(`ทะเบียน`, 15, y);
            doc.setFont("THSarabunNew", "bold");
            doc.text(`${item.REGNO} ${item.DORECV}`, 30, y);
            doc.setFont('THSarabunNew', 'normal');
            doc.text(`สี`, 65, y);
            doc.setFont("THSarabunNew", "bold");
            doc.text(`${item.COLOR}`, 70, y);
            doc.setFont('THSarabunNew', 'normal');
            doc.text(`มามอบให้ผู้ให้กู้ เพื่อยึดถือไว้เป็นประกันหนี้ตามสัญญากูยืมเงิน`, 110, y);

            y += lineHeight;


            doc.text(`และท่านได้ทำสัญญาค้ำประกันหนี้ดังกล่าว รายละเอียดท่านทราบแจ้งชัดดีอยู่แล้วนั้น`, 15, y);

            y += lineHeight;

            doc.setFont('THSarabunNew', 'normal');
            doc.text(`บัดนี้ ผู้กู้ได้ผิดนัดและค้างชำระหนี้ค่างวดที่  ${item.EXP_FRM + ' - ' + item.EXP_TO}  ซึ่งกำหนดชำระ`, 25, y);
            doc.setFont("THSarabunNew", "bold");
            doc.text(`${dayjs(item.FirstUnpaidDate).format('DD/MM/YYYY')}`, 118, y);
            doc.setFont('THSarabunNew', 'normal');
            doc.text(`จำนวน ${item.EXP_PRD} งวดติดต่อกันเป็นจำนวนเงิน`, 138, y);

            y += lineHeight;

            // const amount = Number(item.EXP_AMT) || 0;
            const amount = Number(item?.EXP_AMT ?? 0).toLocaleString('th-TH', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

            const amountThaiText = numberToThaiText(amount);

            doc.setFont("THSarabunNew", "bold");
            doc.text(`${amount} บาท     (${amountThaiText})`, 15, y);
            doc.setFont('THSarabunNew', 'normal');
            doc.text(`ผู้ให้กู้จึงแจ้งมายังท่านเพื่อให้ชำระหนี้ที่ผู้กู้ค้างชำระ`, 115, y);

            y += lineHeight;

            doc.text(`พร้อมดอกเบี้ย เบี้ยปรับ และค่าใช้จ่ายทั้งหมดให้แล้วเสร็จภายใน   7  วัน  นับตังแต่วันที่ท่านได้รับหนังสือฉบับนี้`, 15, y);

            y += lineHeight;
            y += lineHeight;

            doc.setFont('THSarabunNew', 'normal');
            doc.text(`หากท่านเพิกเฉยระยะเวลาตามหนังสือ ท่านไม่ชำระหนี้ผู้ให้กู้มีความจำเป็นที่จะต้อง ดำเนินตามกฎหมายต่อไป`, 15, y);


            y += lineHeight;
            y += lineHeight;


            doc.text(`จึงเรียนมาเพื่อโปรดดำเนินการด่วน`, 30, y);




            // y += 14;

            // --- ส่วนลงนาม (จัดชิดขวา) ---
            // doc.text('ขอแสดงความนับถือ', 130, y,);
            y += 20; // เว้นระยะสำหรับลายเซ็น

            const signatureImg = laiSenBale;  // ใส่ Base64 ของรูปคุณ

            // const offset = 10;
            doc.addImage(signatureImg, 'PNG', 155, 223, 30, 15);

            doc.text('ลงชื่อ....................................', 150, y);
            y += 7;
            doc.text('ผู้ออกจดหมาย', 159, y);

            y += lineHeight;
            y += lineHeight;
            y += lineHeight;
            // y += lineHeight;

            doc.text('- หากท่านได้นำเงินดังกล่าวไปชำระก่อนได้รับจดหมายฉบับนี้ ทางบริษัทต้องขออภัยมา ณ ที่นี้ด้วย', 15, y);
            // y += 7;

            // doc.autoPrint();
            // window.open(doc.output('bloburl'));
        });
        // ฝังคำสั่ง print ลงใน PDF


        // เพิ่มหน้าใหม่
        doc.addPage();

        // ตั้งค่าฟอนต์
        doc.setFont("THSarabunNew", "normal");
        doc.setFontSize(16);

        // config layout
        let finalYLeft = 20;
        let finalYRight = 20;
        let leftX = 10;
        let rightX = 115; // จุดเริ่มคอลัมน์ขวา
        let rowHeight = 30; // ความสูงต่อคน
        let count = 0;
        let columnCount = 0;

        if (type === 'new') {
            dataReprintDemandGuaranter.forEach((person, index) => {
                const x = count % 2 === 0 ? leftX : rightX;
                let y = count % 2 === 0 ? finalYLeft : finalYRight;

                // --- ชื่อ + ประเภท ---
                const nameType = `${person?.customerFullName} (${person?.customerTypeId === 0
                    ? person.contractSchema === "lsfhp"
                        ? "ผู้กู้"
                        : "ผู้เช่าซื้อ"
                    : "ผู้ค้ำประกัน " + person.customerTypeId
                    }) (${person?.CONTNO})`;
                doc.text(nameType, x, y);
                y += 6;

                // --- ที่อยู่ บรรทัด 1 ---
                if (person?.ADDR1) {
                    doc.text(`เลขที่ ${person?.ADDR1}`, x, y);
                    y += 6;
                }

                // --- ที่อยู่ บรรทัด 2 ---
                const addrLine2 = `ต.${person?.TUMB} อ.${person?.AUMPDES} จ.${person?.PROVDES}`;
                doc.text(addrLine2, x, y);
                y += 6;

                // --- ZIP ---
                doc.text(person?.ZIP || "", x, y);

                // --- อัปเดต Y ตามคอลัมน์ ---
                if (count % 2 === 0) {
                    finalYLeft += rowHeight;
                } else {
                    finalYRight += rowHeight;
                    columnCount++;
                }

                count++;

                // --- ถ้าเกิน 9 แถวต่อคอลัมน์ (18 คน) ขึ้นหน้าใหม่ ---
                if (columnCount > 8) {
                    columnCount = 0;
                    console.log(" columnCount 0", columnCount);
                    doc.addPage();
                    doc.setFont("THSarabunNew", "normal");
                    doc.setFontSize(16);
                    finalYLeft = 20;
                    finalYRight = 20;
                }
            });
        } else {
            dataReprintDemandGuaranter.forEach((person, index) => {
                const x = count % 2 === 0 ? leftX : rightX;
                let y = count % 2 === 0 ? finalYLeft : finalYRight;

                // --- ชื่อ + ประเภท ---
                const nameType = `${person?.SNAM + person?.NAME1 + ' ' + person?.NAME2} (${person?.GARNO === 0
                    ? person.contractSchema === "lsfhp"
                        ? "ผู้กู้"
                        : "ผู้เช่าซื้อ"
                    : "ผู้ค้ำประกัน " + person.GARNO
                    }) (${person?.CONTNO})`;
                doc.text(nameType, x, y);
                y += 6;

                // --- ที่อยู่ บรรทัด 1 ---
                if (person?.ADDR1) {
                    doc.text(`เลขที่ ${person?.ADDR1}`, x, y);
                    y += 6;
                }

                // --- ที่อยู่ บรรทัด 2 ---
                const addrLine2 = `ต.${person?.TUMB} อ.${person?.AUMPDES} จ.${person?.PROVDES}`;
                doc.text(addrLine2, x, y);
                y += 6;

                // --- ZIP ---
                doc.text(person?.ZIP || "", x, y);

                // --- อัปเดต Y ตามคอลัมน์ ---
                if (count % 2 === 0) {
                    finalYLeft += rowHeight;
                } else {
                    finalYRight += rowHeight;
                    columnCount++;
                }

                count++;

                // --- ถ้าเกิน 9 แถวต่อคอลัมน์ (18 คน) ขึ้นหน้าใหม่ ---
                if (columnCount > 8) {
                    columnCount = 0;
                    console.log(" columnCount 0", columnCount);
                    doc.addPage();
                    doc.setFont("THSarabunNew", "normal");
                    doc.setFontSize(16);
                    finalYLeft = 20;
                    finalYRight = 20;
                }
            });

        }

        doc.autoPrint();
        const blobUrl = doc.output('bloburl');
        window.open(blobUrl);

    } else {

        //    const PDF_LetterRepurchase = (data = []) => { // เอกสารซื้อรถคืน
        const doc = new jsPDF('p', 'mm', 'a4');

        dataReprintDemandGuaranter.forEach((item, index) => {
            // 1. สร้าง jsPDF object และตั้งค่า

            // let typeCus = item?.cusType === 0 ? '(ผู้เช่าซื้อ)' : `(คนค้ำ ${item.cusType})`;

            if (index > 0) {
                doc.addPage(); // เพิ่มหน้าใหม่
            }
            // const rightMargin = 190; // ขอบขวา 20mm
            // const leftMargin = 30;   // ขอบซ้าย 20mm
            // const contentWidth = rightMargin - leftMargin; // 170mm
            // const pageCenter = 105;
            let y = 20; // ตำแหน่ง Y เริ่มต้น
            const lineHeight = 8; // ระยะห่างบรรทัด (สำคัญเพื่อให้ดูเหมือนเอกสารจริง)


            // doc.addFont('THSarabunNew-normal.ttf', 'THSarabunNew', 'normal');
            // doc.addFont('TH Sarabun New Bold-normal.ttf', 'TH Sarabun New Bold', 'normal');
            doc.setFont('THSarabunNew', 'normal');
            doc.setFontSize(14);

            // --- ส่วนหัว (ชื่อบริษัทและที่อยู่) ---
            doc.setFont('THSarabunNew', 'normal');


            const address = `
                    ชื่อลูกค้า:     ${item.SNAM + item.NAME1 + ' ' + item.NAME2} (คนค้ำ ${item?.GARNO}) (${item?.CONTNO})
                    ที่อยู่:          ${item?.ADDR1} 
                                    ต.${item?.TUMB} อ.${item?.AUMPDES} จ.${item?.PROVDES} ${item?.ZIP}
                    เบอร์โทร:    ${item?.TELP}
                                    (${dayjs(item.RoundDate).format('DD/MM/YYYY')})
        `;
            doc.text(address, 5, y);
            y += 67;

            // --- วันที่ ---
            const dataNow = dayjs(item.RoundDate).format('DD/MM/YYYY');
            doc.text(`วันที่ ${dataNow}`, 160, y, { align: 'right' });
            y += 10;


            const s1 = `
        เรื่อง แจ้งให้ชำระค่าเช่าซื้อที่ค้างชำระ สัญญาเช่าซื้อเลขที่ (${item?.CONTNO})
        `;
            doc.text(s1, 5, y);
            y += 7;

            const s2 = `
        เรียน ${item.SNAM + item.NAME1 + ' ' + item.NAME2} 
        `;
            doc.text(s2, 5, y);
            y += 22;

            // --- เนื้อหา Paragraph 1 ---
            doc.setFont('THSarabunNew', 'normal');

            doc.text('ตามที่ท่านได้ตกลงทำสัญญาค้ำประกันการเช่าซื้อรถยนต์ยี่ห้อ', 25, y);
            doc.setFont("THSarabunNew", "bold");
            doc.text(`${item?.TYPE}`, 110, y);

            doc.setFont('THSarabunNew', 'normal');
            doc.text(' รุ่น ', 135, y);

            // หมายเลขเครื่อง
            doc.setFont("THSarabunNew", "bold");
            doc.text(`${item?.MODEL}`, 150, y);

            y += lineHeight;

            doc.setFont('THSarabunNew', 'normal');
            doc.text(`สี `, 15, y);

            doc.setFont("THSarabunNew", "bold");
            doc.text(`${item?.COLOR}`, 20, y);

            doc.setFont('THSarabunNew', 'normal');
            doc.text(`เลขตัวถัง `, 55, y);
            doc.setFont("THSarabunNew", "bold");
            doc.text(`${item?.STRNO}`, 75, y);

            doc.setFont('THSarabunNew', 'normal');
            doc.text(`เลขเครื่อง `, 115, y);
            doc.setFont("THSarabunNew", "bold");
            doc.text(`${item?.ENGNO}`, 140, y);

            y += lineHeight;

            doc.setFont('THSarabunNew', 'normal');
            doc.text(`ทะเบียน `, 15, y);

            doc.setFont("THSarabunNew", "bold");
            doc.text(`${item?.REGNO + ' ' + item.DORECV}`, 30, y);

            doc.setFont('THSarabunNew', 'normal');
            doc.text(`ระหว่าง ${item.BSNAM + item.BNAME1 + ' ' + item.BNAME2} `, 70, y);
            doc.text(`ผู้เช่าซื้อกับ บริษัท วัน ลิสซิ่ง จำกัด `, 140, y);
            y += lineHeight;

            doc.text(`ผู้ให้เช่าซื้อตามสัญญาเช่าซื้อฉบับลงวันที่  `, 15, y);
            doc.setFont("THSarabunNew", "bold");
            doc.text(`${dayjs(item.SDATE).format('DD/MM/YYYY')}`, 70, y);

            doc.setFont('THSarabunNew', 'normal');
            doc.text(`รายละเอียดที่ท่านทราบดีอยู่แล้วนั้น บัดนี้ผู้เช่าซื้อได้ปฏิบัติผิดสัญญา `, 95, y);

            y += lineHeight;

            const amount = Number(item?.EXP_AMT ?? 0).toLocaleString('th-TH', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
            const amountThaiText = numberToThaiText(amount);

            // doc.setFont("THSarabunNew", "bold");
            doc.text(`โดยค้างชำระค่าเช่าซื้อ งวดที่ ${item.EXP_FRM + ' - ' + item.EXP_TO}`, 15, y);
            doc.text(`ซึ่งกำหนดชำระ`, 65, y);
            doc.setFont("THSarabunNew", "bold");
            doc.text(`${dayjs(item.FirstUnpaidDate).format('DD/MM/YYYY')}`, 90, y);
            doc.setFont('THSarabunNew', 'normal');
            doc.text(`จำนวน ${item.EXP_PRD} งวด ติดต่อกันเป็นจำนวนเงิน`, 110, y);
            doc.setFont("THSarabunNew", "bold");
            doc.text(`${amount} บาท`, 170, y);
            doc.setFont('THSarabunNew', 'normal');

            y += lineHeight;


            doc.setFont('THSarabunNew', 'bold');
            doc.text(`${amountThaiText}  (รวมภาษีมูลค่าเพิ่ม)`, 15, y);

            doc.setFont("THSarabunNew", "normal");
            doc.text(`ส่วนค่าเบี้ยปรับตามกฎหมาย พร้อมค่าใช้จ่ายในการติดตามอื่นๆ `, 105, y);
            y += lineHeight;

            doc.setFont('THSarabunNew', 'normal');
            doc.text(`ขอให้ท่านชำระหนี้ที่ค้างทั้งหมดให้แล้วเสร็จภายใน   7   วัน  นับจากที่ท่านได้รับหนังสือฉบับนี้`, 15, y);

            // doc.setFont("THSarabunNew", "bold");

            y += lineHeight;
            y += lineHeight;

            doc.text(`หากท่านเพิกเฉยระยะเวลาตามหนังสือ ท่านไม่ชำระหนี้ผู้ให้เช่าซื้อมีความจำเป็นที่จะต้อง ดำเนินตามกฎหมายต่อไป`, 15, y);

            y += lineHeight;
            y += lineHeight;


            doc.text(`จึงเรียนมาเพื่อโปรดดำเนินการด่วน`, 30, y);




            // y += 14;

            // --- ส่วนลงนาม (จัดชิดขวา) ---
            // doc.text('ขอแสดงความนับถือ', 130, y,);
            y += 20; // เว้นระยะสำหรับลายเซ็น

            const signatureImg = laiSenBale;  // ใส่ Base64 ของรูปคุณ

            // const offset = 10;
            doc.addImage(signatureImg, 'PNG', 155, 215, 30, 15);

            doc.text('ลงชื่อ....................................', 150, y);
            y += 7;
            doc.text('ผู้ออกจดหมาย', 159, y);

            y += lineHeight;
            y += lineHeight;
            y += lineHeight;
            y += lineHeight;

            doc.text('- หากท่านได้นำเงินดังกล่าวไปชำระก่อนได้รับจดหมายฉบับนี้ ทางบริษัทต้องขออภัยมา ณ ที่นี้ด้วย', 15, y);
            // y += 7;

            // doc.autoPrint();
            // window.open(doc.output('bloburl'));
        });

        // เพิ่มหน้าใหม่
        doc.addPage();

        // ตั้งค่าฟอนต์
        doc.setFont("THSarabunNew", "normal");
        doc.setFontSize(16);

        // config layout
        let finalYLeft = 20;
        let finalYRight = 20;
        let leftX = 10;
        let rightX = 115; // จุดเริ่มคอลัมน์ขวา
        let rowHeight = 30; // ความสูงต่อคน
        let count = 0;
        let columnCount = 0;

        if (type === 'new') {
            dataReprintDemandGuaranter.forEach((person, index) => {
                const x = count % 2 === 0 ? leftX : rightX;
                let y = count % 2 === 0 ? finalYLeft : finalYRight;

                // --- ชื่อ + ประเภท ---
                const nameType = `${person?.customerFullName} (${person?.customerTypeId === 0
                    ? person.contractSchema === "lsfhp"
                        ? "ผู้กู้"
                        : "ผู้เช่าซื้อ"
                    : "ผู้ค้ำประกัน " + person.customerTypeId
                    }) (${person?.CONTNO})`;
                doc.text(nameType, x, y);
                y += 6;

                // --- ที่อยู่ บรรทัด 1 ---
                if (person?.ADDR1) {
                    doc.text(`เลขที่ ${person?.ADDR1}`, x, y);
                    y += 6;
                }

                // --- ที่อยู่ บรรทัด 2 ---
                const addrLine2 = `ต.${person?.TUMB} อ.${person?.AUMPDES} จ.${person?.PROVDES}`;
                doc.text(addrLine2, x, y);
                y += 6;

                // --- ZIP ---
                doc.text(person?.ZIP || "", x, y);

                // --- อัปเดต Y ตามคอลัมน์ ---
                if (count % 2 === 0) {
                    finalYLeft += rowHeight;
                } else {
                    finalYRight += rowHeight;
                    columnCount++;
                }

                count++;

                // --- ถ้าเกิน 9 แถวต่อคอลัมน์ (18 คน) ขึ้นหน้าใหม่ ---
                if (columnCount > 8) {
                    columnCount = 0;
                    console.log(" columnCount 0", columnCount);
                    doc.addPage();
                    doc.setFont("THSarabunNew", "normal");
                    doc.setFontSize(16);
                    finalYLeft = 20;
                    finalYRight = 20;
                }
            });
        } else {
            dataReprintDemandGuaranter.forEach((person, index) => {
                const x = count % 2 === 0 ? leftX : rightX;
                let y = count % 2 === 0 ? finalYLeft : finalYRight;

                // --- ชื่อ + ประเภท ---
                const nameType = `${person?.SNAM + person?.NAME1 + ' ' + person?.NAME2} (${person?.GARNO === 0
                    ? person.contractSchema === "lsfhp"
                        ? "ผู้กู้"
                        : "ผู้เช่าซื้อ"
                    : "ผู้ค้ำประกัน " + person.GARNO
                    }) (${person?.CONTNO})`;
                doc.text(nameType, x, y);
                y += 6;

                // --- ที่อยู่ บรรทัด 1 ---
                if (person?.ADDR1) {
                    doc.text(`เลขที่ ${person?.ADDR1}`, x, y);
                    y += 6;
                }

                // --- ที่อยู่ บรรทัด 2 ---
                const addrLine2 = `ต.${person?.TUMB} อ.${person?.AUMPDES} จ.${person?.PROVDES}`;
                doc.text(addrLine2, x, y);
                y += 6;

                // --- ZIP ---
                doc.text(person?.ZIP || "", x, y);

                // --- อัปเดต Y ตามคอลัมน์ ---
                if (count % 2 === 0) {
                    finalYLeft += rowHeight;
                } else {
                    finalYRight += rowHeight;
                    columnCount++;
                }

                count++;

                // --- ถ้าเกิน 9 แถวต่อคอลัมน์ (18 คน) ขึ้นหน้าใหม่ ---
                if (columnCount > 8) {
                    columnCount = 0;
                    console.log(" columnCount 0", columnCount);
                    doc.addPage();
                    doc.setFont("THSarabunNew", "normal");
                    doc.setFontSize(16);
                    finalYLeft = 20;
                    finalYRight = 20;
                }
            });

        }


        // 3. แสดงผล PDF

        doc.autoPrint();
        const blobUrl = doc.output('bloburl');
        window.open(blobUrl);
    }


}

// export default ReprintDemandGuaranter;